/*/
 * Navigation
/*/
	const siteNav = document.querySelectorAll('[site-nav-toggle]')

	if (siteNav) {
		siteNav.forEach(e => {
			const siteDocument = document.documentElement
			const siteNavElement = document.querySelector('.header--nav')

			e.addEventListener('click', _ => {
				if (siteDocument.classList.contains('is--nav')) {
					siteDocument.classList.remove('is--nav')

					setTimeout(() => {
						siteNavElement.classList.add('d-none')
					}, 1000);
				} else {
					siteNavElement.classList.remove('d-none')

					setTimeout(() => {
						siteDocument.classList.add('is--nav')
					}, 100);
				}
			})
		})
	}

	document.addEventListener('keyup', _ => {
		const siteDocument = document.documentElement

		if (siteDocument.classList.contains('is--nav') && _.key === 'Escape') {
			siteDocument.classList.remove('is--nav')
		}
	})
